<template>
  <b-overlay :show="isLoading">
    <BRow>
      <BCol cols="12">
        <b-card v-if="userDetails">
          <h1>ویرایش کاربر {{ userFullName }}</h1>

          <template v-if="$can('UpdateUserByAdmin', 'Users')">
            <BRow class="py-2 py-md-3 justify-content-center">
              <BCol cols="auto">
                <input
                    ref="avatarPicker"
                    type="file"
                    name="avatar"
                    id="avatar"
                    class="hidden"
                    accept="image/*"
                    @change="convertImageFileToBase64"
                />

                <BButton variant="transparent" type="button" @click="openAvatarPicker">
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <BAvatar :src="handleAvatarImage" size="7rem" />
                    <p v-if="loyaltyName" class="mt-2 mb-0 font-weight-bolder">
                      {{ loyaltyName }}
                    </p>
                  </div>
                </BButton>
              </BCol>
            </BRow>

            <BRow class="p-2">
              <BCol cols="12" md="6">
                <b-form @submit.prevent>
                  <b-form-group label="نام کاربر" label-for="fullName">
                    <b-form-input
                        id="fullName"
                        v-model.trim="userDetails.fullName"
                        placeholder="نام کاربر"
                    />
                  </b-form-group>
                </b-form>
              </BCol>

              <BCol cols="12" md="6">
                <b-form @submit.prevent>
                  <b-form-group label="شماره کاربر" label-for="mobile">
                    <b-form-input
                        id="mobile"
                        v-model.trim="userDetails.mobile"
                        style="direction: ltr;"
                        placeholder="شماره کاربر"
                    />
                  </b-form-group>
                </b-form>
              </BCol>

              <BCol cols="12" md="6">
                <CountryCodePicker
                    v-model="tempSelectedCountry"
                    :default-iso-code="userDetails.countryCode"
                    @getDefaultCountry="setDefaultCountry"
                />
              </BCol>

              <BCol cols="12" md="6">
                <b-form @submit.prevent>
                  <b-form-group label="ایمیل کاربر" label-for="email">
                    <b-form-input
                        id="email"
                        v-model.trim="userDetails.email"
                        placeholder="ایمیل کاربر"
                    />
                  </b-form-group>
                </b-form>
              </BCol>

              <BCol cols="12" md="6">
                <b-form @submit.prevent>
                  <user-type-picker
                      :defaultUserTypeId="userDetails.type"
                      @getUserTypeId="setUserType"
                  />
                </b-form>
              </BCol>

              <BCol cols="12" md="6" v-if="isRenderingLanguagePicker">
                <language-picker
                    :defaultLanguageId="userDetails.languageId"
                    @getLanguage="setLanguage"
                />
              </BCol>

              <BCol cols="12" md="6">
                <b-form @submit.prevent>
                  <b-form-group label="پسورد کاربر" label-for="psswd">
                    <b-form-input
                        id="psswd"
                        v-model.trim="userDetails.password"
                        placeholder="پسورد کاربر"
                    />
                  </b-form-group>
                </b-form>
              </BCol>

              <BCol cols="12" md="6" v-if="userDetails.hasMaster">
                <MasterLevelPicker
                    :defaultSelectedLevel="userDetails.scheduleMasterRegularId"
                    @getMasterLevelId="setMasterLevelId"
                />
              </BCol>

              <BCol cols="12" md="6" v-if="userDetails.hasMaster">
                <PriceCategoryPicker
                    :isMultiple="true"
                    :defaultPriceCategoryIds="userDetails.priceCategoryIds"
                    @getPriceCategory="setPriceCategory"
                />
              </BCol>

              <BCol cols="12" md="6" v-if="userDetails.hasMaster">
                <LiteracyBadgePicker
                    :defaultSelectedLiteracyBadgeId="userDetails.literacyBadgeId"
                    @getLiteracyBadge="setLiteracyBadge"
                />
              </BCol>

              <BCol cols="12" md="6" v-if="userDetails.hasMaster">
                <b-form @submit.prevent>
                  <b-form-group
                      label="قیمت شخصی سازی شده VIP (درآمد تمام کلاس های ثبت شده VIP برای این استاد با این قیمت محاسبه خواهد شد)"
                      label-for="masterCustomeVipPrice"
                  >
                    <b-form-input
                        id="masterCustomeVipPrice"
                        v-model.trim="userDetails.masterCustomeVipPrice"
                        placeholder="80000"
                    />
                  </b-form-group>
                </b-form>
              </BCol>

              <BCol cols="12" md="6">
                <TextInput
                    inputId="whatsAppLink"
                    :inputLabel="userDetails.hasMaster ? 'شماره واتس اپ استاد' : 'شماره واتس اپ زبان آموز'"
                    inputPlaceholder="98912..."
                    v-model="userDetails.whatsAppLink"
                />
              </BCol>

              <BCol cols="12" md="6" class="mt-1" v-if="whatsappLink">
                <small>لینک واتس اپ</small>
                <BButton
                    variant="transparent"
                    target="_blank"
                    :href="whatsappLink"
                    class="d-inline-flex align-items-center"
                >
                  <WhatsappIcon />
                  <span class="ml-1">باز کردن</span>
                </BButton>
              </BCol>
            </BRow>

            <div
                class="w-100 d-flex flex-column flex-md-row align-items-center justify-content-between px-2"
                style="gap: 1rem"
            >
              <div class="w-100 d-flex align-items-center">
                <BButton :variant="isUserDeactivated ? 'success' : 'danger'" v-b-modal.modal-deactive>
                  {{ isUserDeactivated ? "فعال سازی کاربر" : "غیر فعال سازی کاربر" }}
                </BButton>
                <BButton variant="danger" class="ml-1" v-b-modal.modal-delete>
                  حذف کامل کاربر
                </BButton>
              </div>
              <BButton variant="primary" @click="updateUser">
                بروزرسانی کاربر
              </BButton>
            </div>

            <hr
                class="my-2"
                v-if="userDetails.hasMaster && userDetails.scheduleMasterRegular && userDetails.scheduleMasterRegular.canUseCustomePrice"
            />

            <BRow
                v-if="userDetails.hasMaster && userDetails.scheduleMasterRegular && userDetails.scheduleMasterRegular.canUseCustomePrice"
                class="mt-1"
            >
              <BCol cols="12">
                <MasterPriceCategoriesDetails
                    ref="priceCategoryDetails"
                    :masterUserId="$route.params.id"
                    @getPriceCategoryUsers="setTempPriceCategoryUsers"
                />
              </BCol>
            </BRow>

            <BRow v-if="userDetails.hasMaster" class="mt-1">
              <BCol cols="12">
                <hr class="my-2" />
                <UpdateMasterPoints
                    :currentMasterPoints="masterProfileDetails ? masterProfileDetails.points : null"
                    :masterUserId="$route.params.id"
                    @refetch="getMasterProfileDetails"
                />
              </BCol>

              <BCol cols="12">
                <hr class="my-2" />
                <UpdateMasterIntro
                    :currentMasterIntro="masterProfileDetails ? masterProfileDetails.intro : null"
                    :masterUserId="$route.params.id"
                    @refetch="getMasterProfileDetails"
                />
              </BCol>
            </BRow>

            <BRow class="mt-1">
              <BCol cols="12">
                <hr />
              </BCol>

              <BCol cols="12" md="6">
                <b-form-group label="هدف کاربر از خواندن زبان" label-for="goal">
                  <b-form-input id="goal" disabled readonly :value="userDetails.goal" placeholder="هدف کاربر" />
                </b-form-group>
              </BCol>

              <BCol cols="12" md="6">
                <b-form-group label="نحوه آشنایی کاربر با فرمن" label-for="howToIntroduce">
                  <b-form-input
                      id="howToIntroduce"
                      disabled
                      readonly
                      :value="userDetails.howToIntroduce"
                      placeholder="نحوه آشنایی"
                  />
                </b-form-group>
              </BCol>

              <BCol cols="12" md="6">
                <b-form-group label="جنسیت کاربر" label-for="sexuality">
                  <b-form-input
                      id="sexuality"
                      disabled
                      readonly
                      :value="sexuality[userDetails.sexuality]"
                      placeholder="جنسیت"
                  />
                </b-form-group>
              </BCol>

              <BCol cols="12" md="6">
                <b-form-group label="تاریخ تولد کاربر" label-for="birthDate">
                  <b-form-input
                      id="birthDate"
                      disabled
                      readonly
                      :value="createJalaliDate(userDetails.birthDate)"
                      placeholder="تاریخ تولد"
                  />
                </b-form-group>
              </BCol>
            </BRow>
          </template>

          <hr class="my-2" v-if="$can('SetWallet', 'Users')" />
          <BRow>
            <BCol cols="12">
              <UpdateWallet
                  :userData="userDetails"
                  @refetchUser="getASingleUser"
                  @refetchTransactions="refetchTransactions"
              />
            </BCol>
          </BRow>

          <hr class="my-2" v-if="$can('GetWalletDetaileList', 'Wallet')" />
          <BRow>
            <BCol cols="12">
              <WalletTransactions
                  ref="walletTransactions"
                  :userFullName="userFullName"
                  :walletUserId="$route.params.id"
              />
            </BCol>
          </BRow>

          <hr class="my-2" v-if="!userDetails.hasMaster && $can('GetAll', 'Order')" />
          <BRow>
            <BCol cols="12" v-if="!userDetails.hasMaster && $can('GetAll', 'Order')">
              <OrdersList ref="ordersList" :userIdFilter="$route.params.id" />
            </BCol>
          </BRow>

          <hr class="my-2" v-if="!userDetails.hasMaster" />
          <BRow>
            <BCol cols="12" v-if="!userDetails.hasMaster">
              <userBoughtPackageList
                  :canAddLesson="true"
                  :userIdFilter="$route.params.id"
                  @updateOrdersList="updateUserOrdersList"
              />
            </BCol>
          </BRow>

          <hr class="my-2" v-if="!userDetails.hasMaster" />
          <BRow>
            <BCol cols="12" v-if="!userDetails.hasMaster">
              <UserBoughtLessonList
                  :canAddLesson="true"
                  :userIdFilter="$route.params.id"
                  @updateOrdersList="updateUserOrdersList"
              />
            </BCol>
          </BRow>

          <hr class="my-2" v-if="!userDetails.hasMaster" />
          <BRow>
            <BCol cols="12" v-if="!userDetails.hasMaster">
              <UserLoyaltyDetails :userIdFilter="$route.params.id" />
            </BCol>
          </BRow>

          <BRow>
            <BCol cols="12" v-if="!userDetails.hasMaster">
              <StudentScheduleHistory
                  :userFullName="userFullName"
                  :userIdFilter="$route.params.id"
                  :isForAdmin="true"
              />
            </BCol>
          </BRow>
        </b-card>
      </BCol>
    </BRow>

    <b-modal
        :title="isUserDeactivated ? 'فعال سازی کاربر' : 'غیر فعال سازی کاربر'"
        id="modal-deactive"
        centered
        ok-title="بله"
        cancelTitle="خیر"
        @ok="toggleUserActiveState"
    >
      <span>
        آیا از {{ isUserDeactivated ? "فعال سازی این کاربر" : "غیر فعال سازی این کاربر" }} اطمینان دارید ؟
      </span>
    </b-modal>

    <b-modal
        title="حذف کاربر"
        id="modal-delete"
        centered
        ok-variant="danger"
        ok-title="بله"
        cancelTitle="خیر"
        @ok="deleteASingleUser"
    >
      <span>آیا از حذف کامل این کاربر اطمینان دارید؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BAvatar
} from "bootstrap-vue";

import {
  GetASingleUser,
  UpdateUserAsAdmin,
  ChangeUserActivationBy,
  ChangeUserIsShow,
  DeleteASingleUserByAdmin,
  AssignLiteracyBadgeToMaster
} from "@/libs/Api/Users";

import { CreateAMaster, GetMasterDetails } from "@/libs/Api/Master";
import { CreateAStudent } from "@/libs/Api/Student";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UpdateUserScheduleLoyaltyDiscount } from "@/libs/Api/ScheduleLoyaltyDiscount";
import { UpdateUserMasterLevel } from "@/libs/Api/ScheduleMasterRegular";

import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import MasterLevelPicker from "@/views/components/Masters/MasterLevelPicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import WalletTransactions from "@/views/components/Wallet/WalletTransactions.vue";
import UserTypePicker from "@/views/components/UsersType/UserTypePicker.vue";
import UpdateWallet from "@/views/components/Wallet/UpdateWallet.vue";
import OrdersList from "@/views/components/Orders/OrdersList.vue";
import UserBoughtLessonList from "@/views/components/UserBoughtLessons/UserBoughtLessonList.vue";
import userBoughtPackageList from "@/views/components/UserBoughtPackage/userBoughtPackageList.vue";
import UserLoyaltyDetails from "@/views/apps/ScheduleLoyaltyDiscount/UserLoyaltyDetails.vue";
import StudentScheduleHistory from "@/views/apps/MasterSchedule/StudentScheduleHistory.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import WhatsappIcon from "@/views/components/Icons/WhatsappIcon.vue";
import LiteracyBadgePicker from "@/views/components/LiteracyBadges/LiteracyBadgePicker.vue";
import MasterPriceCategoriesDetails from "@/views/apps/PriceCategory/MasterPriceCategoriesDetails.vue";
import CountryCodePicker from "@/views/components/Country/CountryCodePicker.vue";
import UpdateMasterPoints from "@/views/components/Masters/UpdateMasterPoints.vue";
import UpdateMasterIntro from "@/views/components/Masters/UpdateMasterIntro.vue";

export default {
  name: "AdminUserEdit",
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    BAvatar,
    LanguagePicker,
    MasterLevelPicker,
    PriceCategoryPicker,
    WalletTransactions,
    UserTypePicker,
    UpdateWallet,
    OrdersList,
    UserBoughtLessonList,
    userBoughtPackageList,
    UserLoyaltyDetails,
    StudentScheduleHistory,
    TextInput,
    WhatsappIcon,
    LiteracyBadgePicker,
    MasterPriceCategoriesDetails,
    CountryCodePicker,
    UpdateMasterPoints,
    UpdateMasterIntro
  },
  data() {
    return {
      tempSelectedCountry: null,
      sexuality: { 1: "مرد", 2: "زن" },
      userDetails: null,
      userFullName: null,
      isLoading: false,
      selectedUserLoyaltyDiscountId: null,
      selectedMasterLevelId: null,
      selectedLiteracyBadge: null,
      tempPriceCategoryUsers: [],
      masterProfileDetails: null,
      avatarPreview: null,
      newSelfieBase64: "",
      masterDetails: {
        isDeleted: false,
        masterId: 0,
        userId: this.$route.params.id,
        rate: 0,
        rateCount: 0,
        reportCount: 0,
        currentClassesCount: 0,
        closedClassesCount: 0,
        createDate: new Date(Date.now()),
        isActive: true,
        allSetExams: 0,
        allCanceledExams: 0
      },
      studentDetails: {
        isDeleted: false,
        studentId: 0,
        userId: this.$route.params.id,
        lastPassedLessonId: 0,
        nextLessonId: 0,
        createDate: new Date(Date.now()),
        isActive: true
      }
    };
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
    isRenderingLanguagePicker() {
      return !!(this.userDetails && [2, 3, 8].includes(this.userDetails.type));
    },
    isUserDeactivated() {
      return !!(this.userDetails && this.userDetails.status == 0);
    },
    handleAvatarImage() {
      if (this.avatarPreview) return this.avatarPreview;
      if (this.userDetails && this.userDetails.selfieFileData) return this.baseUrl + "/" + this.userDetails.selfieFileData;
      return "";
    },
    loyaltyName() {
      return this.userDetails && this.userDetails.myLevelLoyal && this.userDetails.myLevelLoyal.name
          ? this.userDetails.myLevelLoyal.name
          : "";
    },
    whatsappLink() {
      if (!this.userDetails) return "";
      var raw = this.userDetails.whatsAppLink ? this.userDetails.whatsAppLink : "";
      var digits = String(raw).replace(/\D/g, "");
      if (!digits) return "";

      if (digits.indexOf("00") === 0) digits = digits.slice(2);

      var cc = this.userDetails.countryCode ? String(this.userDetails.countryCode).toUpperCase() : "";
      var isIran = cc === "IR";

      if (isIran && digits.indexOf("98") === 0 && digits.length > 2 && digits.charAt(2) === "0") {
        digits = "98" + digits.slice(3);
      } else if (isIran && digits.charAt(0) === "0") {
        digits = "98" + digits.slice(1);
      }

      return "https://wa.me/" + digits;
    },
    formattedWalletCredit: {
      get: function () {
        if (this.userDetails && this.userDetails.wallet) return this.userDetails.wallet;
        return 0;
      },
      set: function (newValue) {
        if (!this.userDetails) return;
        if (newValue) {
          this.userDetails.wallet = newValue
              .toString()
              .replace(/[^\d\-]/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          this.userDetails.wallet = null;
        }
      }
    }
  },
  mounted() {
    this.getASingleUser();
    this.getMasterProfileDetails();
  },
  methods: {
    withLoading: async function (fn) {
      this.isLoading = true;
      try {
        return await fn();
      } finally {
        this.isLoading = false;
      }
    },
    createJalaliDate: function (date) {
      return date ? new Date(date).toLocaleDateString("fa-IR") : null;
    },
    openAvatarPicker: function () {
      if (this.$refs && this.$refs.avatarPicker) this.$refs.avatarPicker.click();
    },
    convertImageFileToBase64: function (event) {
      var file = event && event.target && event.target.files ? event.target.files[0] : null;
      if (!file) return;

      var reader = new FileReader();
      this.avatarPreview = URL.createObjectURL(file);

      var _this = this;
      reader.onload = function () {
        var result = String(reader.result || "");
        _this.newSelfieBase64 = result.indexOf(",") > -1 ? result.split(",")[1] : "";
        if (event && event.target) event.target.value = "";
      };

      reader.readAsDataURL(file);
    },
    setDefaultCountry: function (countryDetails) {
      this.tempSelectedCountry = countryDetails;
    },
    setUserType: function (userTypeId) {
      if (this.userDetails) this.userDetails.type = userTypeId;
    },
    setLanguage: function (languageId) {
      if (this.userDetails) this.userDetails.languageId = languageId;
    },
    setMasterLevelId: function (id) {
      this.selectedMasterLevelId = id;
    },
    setLiteracyBadge: function (badge) {
      this.selectedLiteracyBadge = badge;
    },
    setTempPriceCategoryUsers: function (priceCategoryUser) {
      var obj = Object.assign({}, priceCategoryUser, { priceCateogryId: priceCategoryUser.priceCategoryId });
      var idx = -1;
      for (var i = 0; i < this.tempPriceCategoryUsers.length; i++) {
        if (this.tempPriceCategoryUsers[i].priceCategoryId == obj.priceCategoryId) {
          idx = i;
          break;
        }
      }
      if (idx > -1) this.tempPriceCategoryUsers.splice(idx, 1, obj);
      else this.tempPriceCategoryUsers.push(obj);
    },
    setPriceCategory: function (priceCategoryIds) {
      if (!this.userDetails) return;

      this.userDetails.priceCategoryIds = priceCategoryIds;

      var ids = priceCategoryIds || [];
      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        var exists = false;
        for (var j = 0; j < this.tempPriceCategoryUsers.length; j++) {
          if (this.tempPriceCategoryUsers[j].priceCategoryId == id) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          this.tempPriceCategoryUsers.push({
            userId: this.$route.params.id,
            priceCategoryId: id,
            priceCateogryId: id,
            platinumMasterPercent: 0,
            platinumMasterUserPercent: 0
          });
        }
      }
    },
    updateUserOrdersList: function () {
      if (this.$refs && this.$refs.ordersList && this.$refs.ordersList.getAllOrdersForAdmin) {
        this.$refs.ordersList.getAllOrdersForAdmin();
      }
    },
    refetchTransactions: function () {
      if (this.$refs && this.$refs.walletTransactions && this.$refs.walletTransactions.getUserWalletDetails) {
        this.$refs.walletTransactions.getUserWalletDetails();
      }
    },
    toastSuccess: function (title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: "CheckIcon",
          variant: "success",
          text: text
        }
      });
    },
    toastError: function (title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: "Trash2Icon",
          variant: "danger",
          text: text
        }
      });
    },
    getMasterProfileDetails: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new GetMasterDetails(_this);
        req.setRequestParam({ userId: _this.$route.params.id });
        await req.fetch(function (res) {
          if (res.isSuccess) _this.masterProfileDetails = res.data;
        });
      });
    },
    assignANewLiteracyBadgeToMaster: async function () {
      var _this = this;
      if (!this.selectedLiteracyBadge || !this.selectedLiteracyBadge.id) return;
      return this.withLoading(async function () {
        var req = new AssignLiteracyBadgeToMaster(_this);
        req.setRequestParam({
          masterId: _this.$route.params.id,
          literacyBadgeId: _this.selectedLiteracyBadge.id
        });
        await req.fetch(function () {});
      });
    },
    updateUserScheduleLoyaltyDiscount: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var q = { userId: _this.$route.params.id };
        if (_this.selectedUserLoyaltyDiscountId) q.discountId = _this.selectedUserLoyaltyDiscountId;
        var req = new UpdateUserScheduleLoyaltyDiscount(_this);
        req.setRequestParam(q);
        await req.fetch(function () {});
      });
    },
    updateMasterLevelRegular: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var q = { userId: _this.$route.params.id };
        if (_this.selectedMasterLevelId) q.id = _this.selectedMasterLevelId;
        var req = new UpdateUserMasterLevel(_this);
        req.setRequestParam(q);
        await req.fetch(function () {});
      });
    },
    toggleUserActiveState: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new ChangeUserActivationBy(_this);
        req.setRequestParam({ id: _this.$route.params.id });
        await req.fetch(function () {
          _this.getASingleUser();
        });
      });
    },
    deleteASingleUser: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new DeleteASingleUserByAdmin(_this);
        req.setRequestParam({ id: _this.$route.params.id });
        await req.fetch(function (res) {
          if (res.isSuccess) {
            _this.toastSuccess("حذف شد!", "کاربر با موفقیت به صورت کامل حذف شد.");
            _this.$router.push("/users");
          } else {
            _this.toastError("مشکلی پیش آمد!", res.errors || "لطفا دوباره تلاش کنید");
          }
        });
      });
    },
    toggleUserIsShow: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new ChangeUserIsShow(_this);
        req.setRequestParam({ userId: _this.$route.params.id });
        await req.fetch(function (res) {
          if (res && res.isSuccess) _this.$router.push("/users");
        });
      });
    },
    checkUserType: function () {
      if (!this.userDetails) return;
      if (this.userDetails.type == 3) this.createASingleMaster();
      if (this.userDetails.type == 4) this.CreateASingleStudent();
    },
    CreateASingleStudent: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new CreateAStudent(_this);
        req.setRequestParamDataObj(_this.studentDetails);
        await req.fetch(function () {}, function () {});
      });
    },
    createASingleMaster: async function () {
      var _this = this;
      if (!this.userDetails || this.userDetails.hasMaster) return;
      return this.withLoading(async function () {
        var req = new CreateAMaster(_this);
        req.setRequestParamDataObj(_this.masterDetails);
        await req.fetch(function () {}, function () {});
      });
    },
    getASingleUser: async function () {
      var _this = this;
      return this.withLoading(async function () {
        var req = new GetASingleUser(_this);
        req.setRequestParam({ id: _this.$route.params.id });
        await req.fetch(
            function (res) {
              if (res.isSuccess) {
                _this.userDetails = res.data;
                _this.userFullName = String(res.data.fullName || "");
                _this.avatarPreview = null;
                _this.newSelfieBase64 = "";
              }
            },
            function () {}
        );
      });
    },
    buildUpdatePayload: function () {
      var u = this.userDetails ? Object.assign({}, this.userDetails) : {};

      if (this.tempSelectedCountry && this.tempSelectedCountry.isoCode) {
        u.countryCode = this.tempSelectedCountry.isoCode;
      }

      if (u.wallet) {
        u.wallet = String(u.wallet).split(",").join("");
      }

      if (this.tempPriceCategoryUsers && this.tempPriceCategoryUsers.length) {
        u.priceCategoryUsers = this.tempPriceCategoryUsers;
      }

      if (this.newSelfieBase64) {
        u.selfieFileData = this.newSelfieBase64;
      } else {
        delete u.selfieFileData;
      }

      return u;
    },
    updateUser: async function () {
      var _this = this;

      return this.withLoading(async function () {
        if (!_this.userDetails) return;

        if (_this.selectedUserLoyaltyDiscountId != _this.userDetails.scheduleLoyaltyDiscountId) {
          await _this.updateUserScheduleLoyaltyDiscount();
        }

        if (_this.selectedLiteracyBadge && _this.selectedLiteracyBadge.id != _this.userDetails.literacyBadgeId) {
          await _this.assignANewLiteracyBadgeToMaster();
        }

        if (_this.selectedMasterLevelId != _this.userDetails.scheduleMasterRegularId) {
          await _this.updateMasterLevelRegular();
        }

        _this.checkUserType();

        var payload = _this.buildUpdatePayload();
        var req = new UpdateUserAsAdmin(_this);
        req.setRequestParamDataObj(payload);

        await req.fetch(
            function (res) {
              if (res.isSuccess) {
                _this.toastSuccess("کاربر با موفقیت ویرایش شد", "");
                _this.tempPriceCategoryUsers = [];
                _this.avatarPreview = null;
                _this.newSelfieBase64 = "";
                _this.getASingleUser();

                if (_this.$refs && _this.$refs.priceCategoryDetails && _this.$refs.priceCategoryDetails.getMasterPriceCategoryDetails) {
                  _this.$refs.priceCategoryDetails.getMasterPriceCategoryDetails();
                }
              } else {
                var e = res.errors || {};
                var duplicatedEmail = e["Email"] === "DuplicatedRecord";
                var duplicatedMobile = e["Mobile"] === "DuplicatedRecord";
                var msg = duplicatedEmail || duplicatedMobile ? "شماره یا ایمیل وارد شده تکراری است!" : (res.errors || "لطفا دوباره تلاش کنید");
                _this.toastError("ویرایش نشد!", msg);
              }
            },
            function () {}
        );
      });
    }
  }
};
</script>
